export enum AccountConfigContactStepEnum {
  CONTACT_FORM,
  LOGO_AND_COLOR_FORM
}

export enum AccountConfigClientStepEnum {
  MANUAL_ADD_CLIENT,
  CLIENT_LIST,
  FINISH_CONFIGURATION
}

export enum AccountingOfficeStageEnum {
  Creator = "Creator",
  // AddTestClient = "AddTestClient", // TODO to remove AddTestClient, TestMainPage and SelectTestNewsPage if not needed
  // TestMainPage = "TestMainPage",
  // SelectTestNewsPage = "SelectTestNewsPage",
  Done = "Done"
}
